import { Injectable, inject } from '@angular/core'
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router'
import { from, Observable, of } from 'rxjs'
import { switchMap } from 'rxjs/operators'

import { SessionService } from '@hunt/services'

@Injectable({ providedIn: 'root' })
export class ArchiveHuntGuard implements CanActivate {
  private readonly router = inject(Router)
  private readonly session = inject(SessionService)
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const id = route.paramMap.get('id')
    if (!id) {
      // no ID → redirect to list
      this.router.navigate(['/hunt', 'hunts'])
      return of(false)
    }

    return from(this.session.loadHunt(id)).pipe(
      switchMap((hunt) => {
        if (!hunt || hunt.archived) {
          this.router.navigate(['/hunt', 'archive-gate'])
          return of(false)
        }
        return of(true)
      }),
    )
  }
}
